class BlogSort {
  constructor(el) {
    this.form = el
    this.select = this.form.querySelector('.sort-results__select')

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)

    this.init()
  }

  /**
   * Handle form submission
   *
   * @param {Event} e
   */
  handleSubmit(e) {
    e.preventDefault()
    this.form.reset()
  }

  applyFilters(sortBy, sort) {
    const { origin, pathname } = window.location
    const url = `${origin}${pathname}`
    const urlParams = new URLSearchParams(window.location.search)

    if (sortBy) {
      urlParams.set('sortby', sortBy)
    } else {
      urlParams.delete('sortby')
    }

    if (sort) {
      urlParams.set('sort', sort)
    } else {
      urlParams.delete('sort')
    }

    const params = urlParams.toString()
    if (params) {
      return this.navigate(`${url}?${params}`)
    }

    return this.navigate(url)
  }

  navigate(url) {
    this.currentUrl = url
    window.location.href = url
  }

  /**
   * Handle Select Update
   */
  handleChange() {
    const { options } = this.select
    const selectedOption = Array.from(options).find(option => option.selected)

    if (selectedOption) {
      const { value } = selectedOption
      const { argument } = selectedOption.dataset

      this.applyFilters(value, argument)
    }
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit)
    this.select.addEventListener('change', this.handleChange)
  }
}

const blogSortInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.sort-results')
    Array.from(wrapperEl).forEach(el => {
      // eslint-disable-next-line no-new
      new BlogSort(el)
    })
  },
}

export default blogSortInit
